import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const REPORT_BOARDS_QUERY_KEY = "reportBoards";

/** Invalidates the report boards list after a board is created, edited or deleted. */
export const useInvalidateReportBoards = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [REPORT_BOARDS_QUERY_KEY]
    });
  }, [queryClient]);
};
